// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TableViewer {\n  height: 85vh;\n  direction: ltr;\n}", "",{"version":3,"sources":["webpack://./src/viewers/TableViewer.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,cAAA;AACF","sourcesContent":[".TableViewer {\n  height: 85vh;\n  direction: ltr;\n  // height: 20em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
